<template>
  <Modal
    v-if="dialog"
    :dialog.sync="dialog"
    title="Настройки синхронизации"
    contentClass="esh-theme adminModal"
    :width="420"
  >
    <template #body>
      <v-card outlined class="infoBody">
        <v-row no-gutters>
          <v-col>
            <v-form v-model="valid">
              <Select
                label="Муниципалитет:"
                v-model="filter.municipality"
                :items="municipalities"
                item-text="short_name"
                item-value="id"
                class="fs-admin-complex-autocomplete mb-5"
                @change="changeDistrict($event)"
                flat
                dense
                blank
              />
              <Select
                label="Школа:"
                v-model="filter.unit"
                :items="schools"
                item-text="short_name"
                item-value="id"
                class="fs-admin-complex-autocomplete"
                flat
                dense
                blank
              />
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <template #actions>
      <v-row align="center" justify="end" no-gutters>
        <v-btn @click="onSave"> <v-icon left>done_all</v-icon> Создать </v-btn>
      </v-row>
    </template>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import { Modal, Select } from "@/components/common";
import {
  GET_SUGGESTION_MUNICIPALITIES,
  GET_SUGGESTION_SCHOOLS,
} from "@/requests/superadmin";

export default {
  name: "NewOperatorModal",
  components: {
    Modal,
    Select,
  },
  props: {
    show: {
      props: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      unit: null,
      municipalities: [],
      schools: [],
      filter: {
        municipality: null,
        unit: null,
      },
      rules: {
        required: (value) => !!value || "Заполните обязательно!",
        positiveInt: (value) =>
          /^\+?([1-9]\d*)$/.test(value) ||
          "Значение должно быть целым положительным числом",
      },
    };
  },
  mounted() {
    this.loadMunicipalities();
  },
  computed: {
    ...mapState({
      clientModes: (state) => state.common.constants.operator_client_modes,
    }),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  watch: {
    show: function (state) {
      if (state) {
        this.schools = [];
        this.municipality = null;
      }
    },
  },
  methods: {
    changeDistrict(districtId) {
      this.filter.unit = null;
      this.schools = [];

      if (districtId !== null) {
        this.loadDistrictSchools(districtId);
      }
    },
    onSave() {
      if (this.filter.unit) this.$emit("save", this.filter.unit);
      else if (this.filter.municipality)
        this.$emit("save", this.filter.municipality);
      else this.$emit("save", null);
      this.$emit("update:dialog", false);
      this.dialog = false;
    },
    async loadDistrictSchools(municipalityId) {
      try {
        const {
          data: { results },
        } = await GET_SUGGESTION_SCHOOLS({
          district: municipalityId,
        });

        this.schools = results;
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Не удалось получить список школ муниципалитета",
        });
      }
    },
    async loadMunicipalities() {
      try {
        const {
          data: { results },
        } = await GET_SUGGESTION_MUNICIPALITIES();
        this.municipalities = results;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "error",
          text: "Не удалось получить список муниципалитетов",
        });
      }
    },
  },
};
</script>
